<template>
  <div>
    <v-dialog
      v-model="isShowUsersModal"
      :overlay="false"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-card v-if="isShowUsersModal">
        <v-app-bar flat class="card-toolbar-title">
          <v-toolbar-title>
            Selected User: {{ selectedUser.oktaUser && selectedUser.oktaUser.profile?selectedUser.oktaUser.profile.firstName:'' }}
            {{ selectedUser.oktaUser && selectedUser.oktaUser.profile?selectedUser.oktaUser.profile.lastName:'' }} - <router-link :to="{ path: '/okta-users', query: { login : selectedUser.userUID }}">{{ selectedUser.userUID }}</router-link>
          </v-toolbar-title>
          <v-spacer />
          <v-btn icon @click.native="closeModal">
            <v-icon>close</v-icon>
          </v-btn>
        </v-app-bar>
        <div>
          <v-tabs
            slot="extension"
            v-model="currentTab"
            centered
            color="secondary"
            slider-color="orange"
          >
            <v-tab href="#tabCurrent">
              Current
            </v-tab>
            <v-tab href="#tabHistory">
              History
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="currentTab">
            <v-tab-item id="tabCurrent">
              <v-card text>
                <v-container fluid grid-list-md>
                  <v-form ref="form">
                    <v-card-actions>
                      <v-layout row justify-center>
                        <v-flex xs12 sm2>
                          <v-autocomplete
                            id="selectedUserGroup"
                            v-model="selectedUserGroup"
                            :items="userGroups"
                            :filter="userGroupsFilter"
                            :hint="selectedUserGroup.userGroupDesc"
                            :rules="required"
                            class="required"
                            name="selectedUserGroup"
                            label="Select User Group To Add"
                            return-object
                          >
                            <template v-slot:selection="data">
                              {{ data.item.userGroupName }}
                            </template>
                            <template v-slot:item="data">
                              {{ data.item.userGroupName }} <span class="subheader">{{ data.item.userGroupDesc }}</span>
                            </template>
                          </v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm1>
                          <v-btn
                            tooltip.hover title="Add a group assignment to this user"
                            fab
                            dark
                            color="primary"
                            @click.native="addUserGroup"
                          >
                            <v-icon dark>add</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-card-actions>
                  </v-form>
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field
                        v-model="currentSearch"
                        append-icon="search"
                        label="Filter Users"
                        single-line
                      />
                      <v-data-table
                        :headers="currentUserTableHeaders"
                        :items="userGroupsForUser.userToGroupList"
                        :search="currentSearch"
                        class="elevation-1"
                        disable-pagination
                        hide-default-footer
                      >
                        <template v-slot:item="props">
                          <tr>
                            <td class="justify-center">
                              <v-btn tooltip.hover title="Inactivate user group" icon class="mx-0" @click="removeUserGroup(props.item.userGroup)">
                                <v-icon color="error">delete</v-icon>
                              </v-btn>
                            </td>
                            <td>{{ props.item.userGroup.userGroupName }}</td>
                            <td>{{ props.item.userGroup.userGroupDesc }}</td>
                            <td>{{ props.item.createdBy }}</td>
                            <td>{{ props.item.createdOn | formatDate }}</td>
                            <td>{{ props.item.lastModifiedBy }}</td>
                            <td>{{ props.item.lastModifiedOn | formatDate }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-tab-item>
            <v-tab-item id="tabHistory">
              <v-card text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-card-actions>
                        <v-text-field
                          v-model="historySearch"
                          append-icon="search"
                          label="Filter Users"
                          single-line
                          hide-details
                        />
                      </v-card-actions>
                      <v-data-table
                        :headers="historyUserTableHeaders"
                        :items="userHistory"
                        :search="historySearch"
                        class="elevation-1"
                        disable-pagination
                        hide-default-footer
                      >
                        <template v-slot:item="props">
                          <tr>
                            <td :class="props.item.recordInactiveFlag === 'A' ? 'add-text-color' : 'remove-text-color'">
                              {{ props.item.recordInactiveFlag === 'A' ? 'Add' : 'Remove' }}
                            </td>
                            <td>{{ props.item.userGroup.userGroupName }}</td>
                            <td>{{ props.item.userGroup.userGroupDesc }}</td>
                            <td>{{ props.item.createdBy }}</td>
                            <td>{{ props.item.createdOn | formatDate }}</td>
                            <td>{{ props.item.lastModifiedBy }}</td>
                            <td>{{ props.item.lastModifiedOn | formatDate }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </v-card>
    </v-dialog>
    <manage-users-remove-user-modal />
  </div>
</template>

<script>
import ManageUsersRemoveUserModal from './ManageUsersRemoveUserModal'
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  name: 'manage-users-user-groups-modal',
  components: {
    ManageUsersRemoveUserModal
  },
  data() {
    return {
      currentTab: 'tabCurrent',
      currentSearch: '',
      historySearch: '',
      addedUserId: '',
      selectedUserGroup: {},
      required: [
        v => !!v.userGroupId || 'Required'
      ],
      currentUserTableHeaders: [{
        text: 'Action',
        value: false,
        sortable: false
      },
      {
        text: 'User Groups',
        value: 'userGroup.userGroupName'
      },
      {
        text: 'User Group Description',
        value: 'userGroup.userGroupDesc'
      },
      {
        text: 'Created By',
        value: 'createdBy'
      },
      {
        text: 'Created On',
        value: 'createdOn'
      },
      {
        text: 'Modified By',
        value: 'lastModifiedBy'
      },
      {
        text: 'Modified On',
        value: 'lastModifiedOn'
      }
      ],
      historyUserTableHeaders: [{
        text: 'Status',
        value: 'recordInactiveFlag'
      }, {
        text: 'User Groups',
        value: 'userGroup.userGroupName'
      },
      {
        text: 'User Group Description',
        value: 'userGroup.userGroupDesc'
      },
      {
        text: 'Created By',
        value: 'createdBy'
      },
      {
        text: 'Created On',
        value: 'createdOn'
      },
      {
        text: 'Modified By',
        value: 'lastModifiedBy'
      },
      {
        text: 'Modified On',
        value: 'lastModifiedOn'
      }
      ],
      addUserTableHeaders: [{
        text: 'Action',
        value: false,
        sortable: false
      },
      {
        text: 'User ID',
        value: 'userId'
      },
      {
        text: 'First Name',
        value: 'firstName'
      },
      {
        text: 'Last Name',
        value: 'lastName'
      },
      {
        text: 'Error Message',
        value: 'errorMessage'
      }
      ]
    }
  },
  computed: {
    ...mapState('manageUsers', ['userGroupsForUser', 'selectedUser', 'userGroups', 'userHistory', 'showUsersModal']),
    isShowUsersModal: {
      get() {
        return this.showUsersModal
      },
      set(value) {
        this.setShowUsersModal(value)
      }
    }
  },
  methods: {
    ...mapActions('manageUsers', ['addUserGroupForUser']),
    ...mapMutations('manageUsers', ['setShowUsersModal', 'setShowRemoveUserModal', 'setSelectedUserGroupInformation']),
    userGroupsFilter(item, queryText, itemText) {
      const lower = val => val ? val.toLowerCase() : ''
      return lower(item.userGroupName).indexOf(lower(queryText)) > -1 || lower(item.userGroupDesc).indexOf(lower(queryText)) > -1
    },
    removeUserGroup(selectedUserGroup) {
      this.setSelectedUserGroupInformation(selectedUserGroup)
      this.setShowRemoveUserModal(true)
    },
    closeModal() {
      this.isShowUsersModal = false
    },
    addUserGroup() {
      if (this.$refs.form.validate()) {
        this.addUserGroupForUser({ user: this.selectedUser, group: this.selectedUserGroup })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .add-text-color {
    color: $color-success;
  }

  .remove-text-color {
    color: $color-danger
  }

  .card-title {
    background-color: $black-3;
    color: $color-primary;
  }

  .card-toolbar-title {
    background-color: $color-secondary;
  }
</style>
